import isEqual from "lodash.isequal";
import { useCallback, useRef } from "react";

type Values = Record<string, any>;

/** Last-saved form values + lbentry; Redux-only edits (e.g. checklists) count as changes. */
export const useSaveBaseline = () => {
  const baseline = useRef<{ values: Values; lbentry: unknown }>();

  const markSaved = useCallback((values: Values, lbentry: unknown) => {
    baseline.current = { values, lbentry };
  }, []);

  const isUnchanged = useCallback(
    (values: Values, lbentry: unknown) =>
      baseline.current !== undefined &&
      isEqual(values, baseline.current.values) &&
      isEqual(lbentry, baseline.current.lbentry),
    [],
  );

  return { markSaved, isUnchanged };
};
